import { Box } from '@mui/material'
import React from 'react'
import type { Control, FieldErrors, UseFormSetValue } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { FORM_FIELDS } from '@/pages/getRecipe/allInOne/utils/formTypes'
import { REGION } from '@/utils/constants'

import ColorSelection from './ColorSelection'

interface ColorSelectionsProps {
  control: Control<any>
  prefix: string
  errors: FieldErrors<any>
  clearErrors: (name?: keyof any | (keyof any)[]) => void
  setValue: UseFormSetValue<any>
  isTripleDentin: boolean
  containerRef?: React.RefObject<HTMLDivElement>
}

const ColorSelections: React.FC<ColorSelectionsProps> = ({
  control,
  prefix,
  errors,
  clearErrors,
  setValue,
  isTripleDentin,
  containerRef,
}) => {
  const { t } = useTranslation()

  if (isTripleDentin) {
    return (
      <Box display="flex" flexDirection="column" gap={2}>
        <ColorSelection
          control={control}
          name={
            prefix === 'prep'
              ? FORM_FIELDS.PREPCOLOR_CERVICAL
              : FORM_FIELDS.TARGETCERVICAL
          }
          title={t(REGION.CERVICAL)}
          error={
            !!errors?.[
              prefix === 'prep'
                ? FORM_FIELDS.PREPCOLOR_CERVICAL
                : FORM_FIELDS.TARGETCERVICAL
            ]
          }
          clearErrors={clearErrors}
          setValue={setValue}
          containerRef={containerRef}
        />
        <ColorSelection
          control={control}
          name={
            prefix === 'prep'
              ? FORM_FIELDS.PREPCOLOR_MIDDLE
              : FORM_FIELDS.TARGETMIDDLE
          }
          title={t(REGION.MIDDLE)}
          error={
            !!errors?.[
              prefix === 'prep'
                ? FORM_FIELDS.PREPCOLOR_MIDDLE
                : FORM_FIELDS.TARGETMIDDLE
            ]
          }
          clearErrors={clearErrors}
          setValue={setValue}
          containerRef={containerRef}
        />
        <ColorSelection
          control={control}
          name={
            prefix === 'prep'
              ? FORM_FIELDS.PREPCOLOR_INCISAL
              : FORM_FIELDS.TARGETINCISAL
          }
          title={t(REGION.INCISAL)}
          error={
            !!errors?.[
              prefix === 'prep'
                ? FORM_FIELDS.PREPCOLOR_INCISAL
                : FORM_FIELDS.TARGETINCISAL
            ]
          }
          clearErrors={clearErrors}
          setValue={setValue}
          containerRef={containerRef}
        />
      </Box>
    )
  }

  return (
    <Box>
      <ColorSelection
        control={control}
        name={
          prefix === 'prep'
            ? FORM_FIELDS.PREPCOLOR_MIDDLE
            : FORM_FIELDS.TARGETMIDDLE
        }
        title={t(REGION.MIDDLE)}
        error={
          !!errors?.[
            prefix === 'prep'
              ? FORM_FIELDS.PREPCOLOR_MIDDLE
              : FORM_FIELDS.TARGETMIDDLE
          ]
        }
        clearErrors={clearErrors}
        setValue={setValue}
        containerRef={containerRef}
      />
    </Box>
  )
}

export default ColorSelections
